export const languageNumericEnum = {
    1: 'Pl',
    2: 'En',
    3: 'Ru',
    4: 'Ua',
};